import React from 'react'

export const ListHeader = () => {
  return (
    <thead>
      <tr>
        <th style={{ width: '40%' }}>Item</th>
        <th style={{ width: '20%' }} className="text-end">
          Quantity
        </th>
        <th className="text-end">Price</th>
        <th className="text-end">Discount</th>
        <th style={{ width: '20%' }} className="text-end">
          Amount
        </th>
        <th />
      </tr>
    </thead>
  )
}
